import { render, staticRenderFns } from "./DailyTimeBreakdown.vue?vue&type=template&id=506e13b2"
import script from "./DailyTimeBreakdown.vue?vue&type=script&lang=js"
export * from "./DailyTimeBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports